import { Flex, theme, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { NAV_ITEMS, findActiveNavKey } from './navItems'

/**
 * Pastki tab-bar — mobil ekranda ASOSIY navigatsiya (UI/UX talabi: abonent
 * ko'pincha telefondan kiradi, "mobil birinchi"). Har doim besh element:
 * ro'yxat o'sib ketmasligi kerak, aks holda tugmalar torayib bosish
 * qiyinlashadi.
 */
export function MobileTabBar() {
  const { t } = useTranslation()
  const { token } = theme.useToken()
  const location = useLocation()
  const navigate = useNavigate()
  const activeKey = findActiveNavKey(location.pathname)

  return (
    <nav
      className="xsib-tabbar"
      style={{
        background: token.colorBgContainer,
        borderTop: `1px solid ${token.colorBorderSecondary}`,
      }}
    >
      <Flex justify="space-around" align="center" style={{ height: 64 }}>
        {NAV_ITEMS.map((item) => {
          const active = item.key === activeKey
          return (
            <button
              key={item.key}
              type="button"
              onClick={() => navigate(item.path)}
              aria-current={active ? 'page' : undefined}
              style={{
                background: 'none',
                border: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                padding: '6px 8px',
                minWidth: 56,
                color: active ? token.colorPrimary : token.colorTextSecondary,
                cursor: 'pointer',
              }}
            >
              <span style={{ fontSize: 20 }}>{item.icon}</span>
              <Typography.Text style={{ fontSize: 11, color: 'inherit' }}>
                {t(item.labelKey)}
              </Typography.Text>
            </button>
          )
        })}
      </Flex>
    </nav>
  )
}
